'use client';

import utilsStyles from '@/styles/modules/utils.module.scss';
import type { Route } from 'next';
import { useRouter } from 'next/navigation';
import styles from './SiteNotification.module.scss';

function SiteNotification({
  title,
  link,
}: {
  title: string;
  link: string;
}) {
  const router = useRouter();
  const handleClick = () => {
    router.push(link as Route);
  };

  return (
    <>
      <div className={styles.siteNotifications}>
        <p className={`${utilsStyles.textUnderlined} ${utilsStyles.textEllipsis}`} onClick={handleClick}>
          {title}
        </p>
      </div>
    </>
  );
}

export default SiteNotification;
